// extracted by mini-css-extract-plugin
export var articleItem = "post-small-module--articleItem--52a56";
export var catDateWrapper = "post-small-module--catDateWrapper--63494";
export var postCategories = "post-small-module--postCategories--6628d";
export var postDate = "post-small-module--post-date--f7a2e";
export var postExcerpt = "post-small-module--post-excerpt--40516";
export var postImg = "post-small-module--post-img--7cbe4";
export var postItem = "post-small-module--post-item--17d53";
export var postTitle = "post-small-module--post-title--be91b";
export var readTime = "post-small-module--read-time--ba96b";